import React from 'react';
import { useParams } from 'react-router-dom';
import UsageDetailView, { Field, UsageDetailPage, UsageEntriesQuery } from '../converter/UsageDetailView';
import { adminApiService } from '../../services/adminApi';
import { AdminWebUsageJob } from '../../types/admin';
import { formatDateTimeUTC, formatDuration } from '../../utils/dateTime';
import { instanceLabel } from './shared';

async function loadJob(id: string, query: UsageEntriesQuery): Promise<UsageDetailPage<AdminWebUsageJob>> {
  const res = await adminApiService.getWebJob(id, query);
  return { subject: res.job, entries: res.items, total: res.total };
}

function AdminWebJobDetail() {
  const { id } = useParams<{ id: string }>();

  return (
    <UsageDetailView<AdminWebUsageJob>
      id={id}
      backTo="/admin/usage?tab=web"
      pageSizeKey="admin-web-job-files"
      load={loadJob}
      showOutputTokens
      noun="job"
      title={(job) => job.project_name || job.operation}
      // Usage outlives its job. Only a deleted job gets a marker.
      titleAside={(job) => (job.status === 'deleted' ? <span className="text-secondary">deleted</span> : null)}
      fields={(job) => (
        <>
          <Field label="Instance">{instanceLabel(job.instance_name, job.instance_key)}</Field>
          <Field label="Operation">{job.operation}</Field>
          <Field label="Started At">{formatDateTimeUTC(job.started_at)}</Field>
          <Field label="Completed At">{formatDateTimeUTC(job.completed_at)}</Field>
          <Field label="Duration">{job.started_at ? formatDuration(job.started_at, job.completed_at) : '—'}</Field>
        </>
      )}
    />
  );
}

export default AdminWebJobDetail;
